import React from 'react';
import { Link } from 'react-router-dom';
import Bgimg from '../../assets/images/shapes/service-bg-1.jpg';
import Service1 from '../../assets/images/services/sv-1.jpg';
import Service2 from '../../assets/images/services/sv-2.jpg';
import Service3 from '../../assets/images/services/sv-3.jpg';

const services = [
  {
    image: Service1,
    icon: "icon-consulting",
    category: "Recruitment",
    title: "IT Recruitment",
    link: "/services",
    text: "Specialized hiring solutions for software, technology, and IT-enabled services."
  },
  {
    image: Service2,
    icon: "icon-controller",
    category: "Recruitment",
    title: "Non-IT Recruitment",
    link: "/services",
    text: "Talent acquisition for sales, marketing, finance, operations, HR, manufacturing, and other industries."
  },
  {
    image: Service3,
    icon: "icon-policy",
    category: "Training",
    title: "Digital Marketing Training",
    link: "/services",
    text: "Providing comprehensive training programs to enhance digital marketing skills and knowledge."
  },
  {
    image: Service1,
    icon: "icon-team",
    category: "Campus",
    title: "Campus Hiring",
    link: "/services",
    text: "Connecting fresh graduates with organizations through structured campus recruitment programs."
  },
  {
    image: Service2,
    icon: "icon-training",
    category: "Training",
    title: "Internship & Training Programs",
    link: "/services",
    text: "Providing industry-focused training and internship opportunities to enhance employability and practical skills."
  },
  {
    image: Service3,
    icon: "icon-consulting",
    category: "HR Solutions",
    title: "HR Consulting",
    link: "/services",
    text: "Supporting businesses with workforce planning, talent management, HR policies, and organizational development."
  },
//   {
//     image: Service1,
//     icon: "icon-career",
//     category: "Career Support",
//     title: "Career Guidance & Placement",
//     link: "/services",
//     text: "Assisting job seekers with career planning, resume building, interview preparation, and job placements."
//   },
//   {
//     image: Service2,
//     icon: "icon-digital-service",
//     category: "Digital Hiring",
//     title: "Digital Hiring Solutions",
//     link: "/services",
//     text: "Leveraging modern recruitment tools, job portals, and social media platforms to attract top talent."
//   }
];

function Service() {
    return (
        <div>
            <section className="service-one" style={{ backgroundImage: `url(${Bgimg})` }}>
                <div className="container">
                    <div className="sec-title text-center">
                        <h6 className="sec-title__tagline">Our Service area</h6>
                        <h3 className="sec-title__title">
                            Outsourced Hiring &amp; Job <br />
                            Rules Services
                        </h3>
                    </div>
                    <div className="row gutter-y-30">
                        {services.map((service, index) => (
                            <div key={index} className="col-md-6 col-lg-4">
                                <div className="service-one-card service-card-two" data-wow-duration="1500ms" data-wow-delay={`${index}ms`}>
                                    <div className="service-one-card__image">
                                        <img src={service.image} alt={service.title} />
                                    </div>
                                    <div className="service-one-card__content">
                                        <div className="service-one-card__icon">
                                            <i className={service.icon} />
                                            <Link to="/services" className="service-one-card__cat">
                                                {service.category}
                                            </Link>
                                        </div>
                                        <h3 className="service-one-card__title">
                                            <Link to={service.link}>{service.title}</Link>
                                        </h3>
                                        <p className="service-one-card__text">
                                            {service.text}
                                        </p>
                                    </div>
                                    <Link to={service.link} className="service-one-card__link">
                                        Read More
                                        <i className="icon-right-arrow" />
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Service;
